export default __webpack_public_path__ + "static/media/ic_kaspersky.a5cd119a.png";